var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F1564C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C51.0457 20 60 28.9543 60 40H20C20 28.9543 28.9543 20 40 20Z",
    fill: "#F1564C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0002 25.8333C47.8242 25.8333 54.1668 32.1759 54.1668 39.9999H25.8335C25.8335 32.1759 32.1761 25.8333 40.0002 25.8333Z",
    fill: "#FC8B46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 32.5C44.1421 32.5 47.5 35.8579 47.5 40H32.5C32.5 35.8579 35.8579 32.5 40 32.5Z",
    fill: "#FDBB53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6173 42.5H37.5748C38.2219 42.5 38.7466 43.0272 38.7466 43.6775C38.7466 43.936 38.6619 44.1874 38.5056 44.3928L30.1982 55.3088C29.7521 55.8949 28.9176 56.0068 28.3342 55.5585C28.2407 55.4867 28.1571 55.4027 28.0857 55.3088L20.3299 45.1176C19.7862 44.4032 19.9219 43.3812 20.6328 42.8349C20.9155 42.6177 21.2614 42.5 21.6173 42.5Z",
    fill: "#2A3638"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4219 42.5H58.3794C59.2744 42.5 60 43.2291 60 44.1284C60 44.486 59.8829 44.8336 59.6667 45.1176L51.911 55.3088C51.4649 55.8949 50.6303 56.0068 50.047 55.5585C49.9535 55.4867 49.8699 55.4027 49.7984 55.3088L41.491 44.3928C41.0979 43.8762 41.196 43.1372 41.7101 42.7421C41.9144 42.5851 42.1646 42.5 42.4219 42.5Z",
    fill: "#2A3638"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8335 42.5H54.1668L41.1212 59.4474C40.6428 60.0688 39.7531 60.1833 39.1339 59.7031C39.0385 59.6291 38.9529 59.5432 38.8792 59.4474L25.8335 42.5Z",
    fill: "#5F6257"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3335 42.5H46.6668L40.4642 50.6045C40.2689 50.8596 39.9029 50.9089 39.6466 50.7145C39.605 50.6829 39.5679 50.646 39.5362 50.6045L33.3335 42.5Z",
    fill: "#919078"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsle);
export default __webpack_public_path__ + "static/media/isle.5dd23c3a5f3366992b7befe93d323ff0.svg";
export { ForwardRef as ReactComponent };